import { ILocationMapper } from "shared/model/ILocationMapper";

export interface IGoogleMappedLocation {
  mapped: boolean;
  value: string;
  removeStaticKeywords: boolean;
  businessType?: string;
}

export default class GooglePlacesLocationMapper {
  private locationMaps: { [name: string]: ILocationMapper };

  constructor() {
    this.locationMaps = require("./locations.json");
  }

  public map(query: string): IGoogleMappedLocation {
    const lowercaseQuery = query.toLowerCase();
    const mapper = this.findMap(lowercaseQuery);
    if (mapper) {
      const value = lowercaseQuery.replace(mapper.query, mapper.replacement);
      return {
        mapped: true,
        value,
        removeStaticKeywords: mapper.removeStaticKeywords,
        businessType: mapper.businessType
      };
    } else {
      return {
        mapped: false,
        value: query,
        removeStaticKeywords: false
      };
    }
  }

  private findMap(query: string) {
    const mapper = this.locationMaps[query];
    if (mapper) {
      return mapper;
    } else {
      const mapKeys = Object.keys(this.locationMaps).filter(mapKey =>
        query.startsWith(this.locationMaps[mapKey].query)
      );

      if (mapKeys.length) {
        const mapKey = mapKeys[0];
        return this.locationMaps[mapKey];
      }

      return undefined;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/Google/GooglePlacesLocationMapper.ts